import request from '../request.js'

const insertSysGroup = function (data) {
    return request({
        url: 'sysGroup/insertSysGroup',
        method: 'post',
        data
    })
}

const getSysGroupInfo = function (data) {
    return request({
        url: 'sysGroup/getSysGroupInfo',
        method: 'post',
        data
    })
}

const getPageGroups = function (data) {
    return request({
        url: 'sysGroup/getPageGroups',
        method: 'post',
        data
    })
}

const deleteSysGroups = function (data) {
    return request({
        url: 'sysGroup/deleteSysGroups',
        method: 'post',
        data
    })
}

const insertVirtualDept = function (data) {
    return request({
        url: 'sysStation/insert',
        method: 'post',
        data
    })
}

const getVirtualDeptInfo = function (data) {
    return request({
        url: 'sysStation/selectById',
        method: 'post',
        data
    })
}

const removeVirtualDept = function (data) {
    return request({
        url: 'sysStation/deleteById',
        method: 'post',
        data
    })
}

const getVirtualDeptTree = function (data) {
    return request({
        url: 'sysStation/selectVirtualDeptTree',
        method: 'post',
        data
    })
}

const getDictsByValue = function (data) {
    return request({
        url: 'sysDict/getDictsByValue',
        method: 'post',
        data
    })
}

const saveUserStations = function (data) {
    return request({
        url: 'sysUserStation/saveUserStations',
        method: 'post',
        data
    })
}

const deleteGroupUser = function (data) {
    return request({
        url: 'sysUserGroup/deleteGroupUser',
        method: 'post',
        data
    })
}

const getAllGroups = function (data) {
    return request({
        url: 'sysGroup/getAllGroups',
        method: 'post',
        data
    })
}
export {
    insertSysGroup,
    getSysGroupInfo,
    getPageGroups,
    deleteSysGroups,
    insertVirtualDept,
    getVirtualDeptTree,
    removeVirtualDept,
    getVirtualDeptInfo,
    getDictsByValue,
    saveUserStations,
    deleteGroupUser,
    getAllGroups
}